var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "94px",
    height: "99.333px",
    viewBox: "0 0 94 99.333",
    enableBackground: "new 0 0 94 99.333",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFE3C7",
    stroke: "#FFE3C7",
    strokeMiterlimit: 10,
    points: "44.651,1 1,29.151 53.507,98.423 92.73,63.63  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg4);
export default __webpack_public_path__ + "static/media/bg4.1785eb8bb633cb41fab14e660b77c242.svg";
export { ForwardRef as ReactComponent };